import { Trans } from '@lingui/react';
import { i18n } from '@lingui/core';
import React from 'react';
import { useBreakpoint, useNavBarContext as useNavBarContext$1, DropdownMenu, IconButton, HelpOutlined, callAllHandlers, List } from '@landr/maestro';
import { useLinkClickHandler } from '../../../../hooks/useLinkClickHandler.es.js';
import { useFeedbackModal } from '../NavBarFeedbackModal/FeedbackModalProvider.es.js';
import { convertLocale } from '../../../../../../utils/convertLocale.es.js';
import { openSupportLink } from '../../../../../../utils/links.es.js';
import { useNavBarContext } from '../../../../../../contexts/NavBarProvider/NavBarContext.es.js';
import { getSupportLink } from '@landr/core';

var getNavBarHelpMobileTrigger = function getNavBarHelpMobileTrigger() {
  return /*#__PURE__*/React.createElement(List.Item, null, /*#__PURE__*/React.createElement(List.ItemIcon, null, /*#__PURE__*/React.createElement(HelpOutlined, null)), /*#__PURE__*/React.createElement(Trans, {
    id: "Help"
  }));
};
var NavBarHelp = function NavBarHelp() {
  var isMobile = useBreakpoint('md');
  var _useNavBarContext = useNavBarContext(),
    env = _useNavBarContext.env,
    language = _useNavBarContext.language;
  var _useMaestroNavBarCont = useNavBarContext$1(),
    closePanel = _useMaestroNavBarCont.closePanel;
  var locale = convertLocale(language);
  var _useFeedbackModal = useFeedbackModal(),
    openModal = _useFeedbackModal.openModal;
  var handleLinkClick = useLinkClickHandler(closePanel);
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    placement: "bottom-end",
    offset: [0, 8]
  }, /*#__PURE__*/React.createElement(DropdownMenu.Trigger, null, isMobile ? getNavBarHelpMobileTrigger() : /*#__PURE__*/React.createElement(IconButton, {
    size: "sm",
    label: /*i18n*/i18n._("Help"),
    icon: HelpOutlined,
    variant: "ghost",
    kind: "minimal",
    isRounded: true
  })), /*#__PURE__*/React.createElement(DropdownMenu.List, null, /*#__PURE__*/React.createElement(DropdownMenu.Item, {
    as: "a",
    onClick: callAllHandlers(closePanel, handleLinkClick(openSupportLink, env, "/hc/".concat(locale))),
    href: getSupportLink(env, "/hc/".concat(locale))
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "FAQ"
  })), /*#__PURE__*/React.createElement(DropdownMenu.Item, {
    onClick: callAllHandlers(closePanel, openModal)
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Give feedback"
  })), /*#__PURE__*/React.createElement(DropdownMenu.Item, {
    as: "a",
    onClick: callAllHandlers(closePanel, handleLinkClick(openSupportLink, env, "/hc/".concat(locale, "/requests/new"))),
    href: getSupportLink(env, "/hc/".concat(locale, "/requests/new"))
  }, /*#__PURE__*/React.createElement(Trans, {
    id: "Contact support"
  }))));
};

export { NavBarHelp };
